import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/** Ensures document pages load scrolled to top (hash routes handled separately on home). */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
